/**
 * @type {{[key: string]: import('$lib/utils/page').PageCondition}}
 */
const pageConditions = {
	default: {
		condition: async () => true,
		resolve: async () => await import('../_browser/Page.svelte'),
	},
};

export { pageConditions };
